import { useTranslation } from "react-i18next";
import { EnvelopeSimple, Phone, Clock } from "@phosphor-icons/react";

export const ContactHero = () => {
  const { t } = useTranslation();

  const channels = [
    {
      icon: EnvelopeSimple,
      label: t("contact.channels.email_label"),
      value: t("contact.channels.email_value"),
      href: `mailto:${t("contact.channels.email_value")}`,
      soon: false,
    },
    {
      icon: Phone,
      label: t("contact.channels.phone_label"),
      value: t("contact.channels.phone_value"),
      soon: true,
    },
    {
      icon: Clock,
      label: t("contact.channels.hours_label"),
      value: t("contact.channels.hours_value"),
      soon: false,
    },
  ];

  return (
    <section
      data-testid="contact-hero"
      className="relative pt-36 pb-16 md:pt-44 md:pb-20 overflow-hidden"
    >
      <div className="absolute inset-0 adonis-grid-bg [mask-image:radial-gradient(ellipse_at_top,black_25%,transparent_70%)]" />

      <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center">
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] text-slate-900">
          {t("contact.hero.title_a")}{" "}
          <span className="adonis-gradient-text">
            {t("contact.hero.title_b")}
          </span>
        </h1>
        <p className="mt-6 mx-auto max-w-2xl text-base md:text-lg leading-relaxed text-slate-600">
          {t("contact.hero.subtitle")}
        </p>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mx-auto">
          {channels.map((c, i) => {
            const Icon = c.icon;
            return (
              <div
                key={i}
                data-testid={`contact-channel-${i}`}
                className="rounded-2xl border border-slate-200 bg-white p-5 text-left"
              >
                <div className="flex items-center justify-between">
                  <Icon size={20} weight="light" className="text-slate-400" />
                  {c.soon && (
                    <span className="rounded-full bg-amber-50 border border-amber-100 px-2 py-0.5 text-[9px] font-bold uppercase tracking-[0.15em] text-amber-700">
                      {t("contact.channels.kicker")}
                    </span>
                  )}
                </div>
                <p className="mt-4 text-[10px] uppercase tracking-wider text-slate-500 font-bold">
                  {c.label}
                </p>
                <p className="mt-1 font-heading text-base font-bold tracking-tight text-slate-900">
                  {c.href ? (
                    <a
                      href={c.href}
                      className="hover:underline underline-offset-4 decoration-slate-400 break-all"
                    >
                      {c.value}
                    </a>
                  ) : (
                    c.value
                  )}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
